import React from "react"
import './NavBar.css';
import Signup from "../../../sign-up/Signup";
import { useNavigate } from "react-router-dom";


export default function NavBar()
{
  let navigate = useNavigate();
  const Signup = () => {
    navigate("/Signup");
  } 
return(
    <div>
        <nav className="navbar navbar-expand  navbar-con">
          <div className="container-fluid">
          <div className="d-flex justify-content-start">
                  <a className="navbar-brand" href="#">
                      <img src="./assets/png/logo2.png" className="logo"/>
                  </a>
                </div>
          </div>
          <div className="d-flex">
                <div className="d-flex justify-content-end">
                  <button className="btn  btn-lg btn-block Signup-btn" onClick={Signup}>Sign Up</button>
                </div>
            </div>
        </nav>
    </div>

)
}